import React, { useState, useEffect, useRef } from "react";
import "gridstack/dist/gridstack.css";
import { GridStack } from "gridstack";
import "./omaxDashboard.css";
import { Box, Button, Switch } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import {
  ZoomIn,
  ZoomOut,
  Computer,
  PowerSettingsNewRounded,
  Close,
} from "@mui/icons-material";

import { renderToStaticMarkup } from "react-dom/server";
import { ASSET_IMAGES } from "app/utils/constants/paths";
import { useSelector } from "react-redux";
import { dispatch } from "app/store/store";
import {
  GetDashboardPreInfoDataThunk,
  GetGraphAndSummaryDataThunk,
} from "app/store/slice/supply-dashboard-slice";

import { unwrapResult } from "@reduxjs/toolkit";
import { clone } from "sortablejs";
import cloneDeep from "lodash.clonedeep";
import { convertDateFormat, nFormatter } from "app/utils/utils";
import Datagrid from "app/Common/Datagrid";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";

const SupplyDashboardView = (props) => {
  let { startdate, enddate, sortBy, mustFilters, mustNotFilters, filterBars } =
    props.dashboardFilters;

  const { showsummaryfilters, summary_options_ext } = props.preDefinedProps;

  const { authUserData } = useSelector((state) => state.CommonReducer);
  const [listGridInstance, setListGridInstance] = useState(null);
  const [minimizedViewGridInstance, setMinimizedViewGridInstance] =
    useState(null);
  const [filtersBarGridInstance, setFiltersBarGridInstance] = useState(null);
  const [listGridTiles, setListGridTiles] = useState(props.gridSelection);

  /*** Sudheer Code */
  const [fullViewGrid, setFullViewGrid] = useState({});

  useEffect(() => {
    // Initialize GridStack when the component mounts
    const options = {
      // Add your GridStack options here
      float: false,
      animate: true,
      // alwaysShowResizeHandle: false,
      //cellHeight: 1,
      height: 0,
      // minWidth: 768,
      resizable: {
        autoHide: true,
        handles: "n",
      },
      staticGrid: false,
      verticalMargin: 5,
      cellHeight: 65,
      autoFit: true, // just fit based on tallest content.
      autoFitByOverflow: true,
    };
    const options2 = {
      // Add your GridStack options here
      float: false,
      animate: true,
      alwaysShowResizeHandle: false,
      //cellHeight: 1,
      height: "auto",
      // minWidth: 768,
      resizable: {
        autoHide: true,
        handles: "n",
      },
      staticGrid: false,
      verticalMargin: 5,
      //cellHeight: "auto",
      autoFit: true, // just fit based on tallest content.
      autoFitByOverflow: true,
      sizeToContent: true,
    };

    const filtersBarOptions = {
      // Add your GridStack options here
      float: false,
      animate: true,
      // alwaysShowResizeHandle: false,
      //cellHeight: 1,
      height: 0,
      // minWidth: 768,
      resizable: {
        autoHide: true,
        handles: "n",
      },
      staticGrid: false,
      verticalMargin: 5,
      cellHeight: 65,
      autoFit: true, // just fit based on tallest content.
      autoFitByOverflow: true,
    };

    const detailsGrid = GridStack.init(options2, ".grid-stack-minimizedview");
    const grid = GridStack.init(options, ".grid-stack-list");
    const fitlersBarGrid = GridStack.init(
      filtersBarOptions,
      ".grid-stack-filterbars"
    );

    // Set the grid instance in state
    setListGridInstance(grid);
    setMinimizedViewGridInstance(detailsGrid);
    setFiltersBarGridInstance(fitlersBarGrid);
    // Clean up when the component unmounts
    return () => {
      listGridInstance.destroy();
      minimizedViewGridInstance.destroy();
      filtersBarGridInstance.destroy();
    };
  }, []);

  useEffect(() => {
    if (listGridInstance) {
      listGridInstance.removeAll(); // Clear existing grid items
      listGridTiles.forEach((item) => {
        if (item.state == 1) {
          listGridInstance.addWidget(renderGridItem(item)); // Add each item to the grid
        }
      });

      document.querySelectorAll(".expandGrid").forEach((button) => {
        button.addEventListener("click", function () {
          expandGridHandler(button.getAttribute("id"));
        });
      });

      document.querySelectorAll(".fullviewgrid").forEach((button) => {
        button.addEventListener("click", function () {
          fullViewGridHandler(button.getAttribute("id"));
        });
      });
    }
  }, [listGridInstance, listGridTiles, props.dashboardFilters]);

  useEffect(() => {
    if (filtersBarGridInstance) {
      filtersBarGridInstance.removeAll(); // Clear existing grid items
      Object.keys(filterBars).forEach((key) => {
        let item = filterBars[key];
        filtersBarGridInstance.addWidget(renderFiltersBarGridItem(item, key)); // Add each item to the grid
      });

      document.querySelectorAll(".filter_switch").forEach((button) => {
        button.addEventListener("click", function () {
          toggleFilterBars(button.getAttribute("data-filter-id"));
        });
      });

      document.querySelectorAll(".filter_poweroff").forEach((button) => {
        button.addEventListener("click", function () {
          removeFilterBars(button.getAttribute("data-filter-id"));
        });
      });
    }
  }, [filtersBarGridInstance, filterBars]);

  useEffect(() => {
    if (minimizedViewGridInstance) {
      minimizedViewGridInstance.getGridItems().forEach((widgetItem) => {
        const widgetIdInGrid = widgetItem.getAttribute("widget-id");

        updateItemInMinimizedView(widgetIdInGrid, "", [], true);
        getMinimizedViewGridData(widgetIdInGrid);
      });
    }

    if (Object.keys(fullViewGrid).length > 0) {
      setFullViewGrid((prevState) => {
        return {
          ...prevState,
          loader: true,
        };
      });
      getFullViewData(fullViewGrid.key);
    }
  }, [props.dashboardFilters]);

  function renderFiltersBarGridItem(item, key) {
    const gridItem = (
      <Box
        className="grid-stack-item"
        gs-w="4"
        gs-h="1"
        style={{ display: item.hidden ? "none" : "" }}
      >
        <Box className="grid-stack-item-content">
          <Box
            className="filterdiv"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: item.invert ? "1px solid #fff" : "1px solid #26a65b",
              backgroundColor: item.invert ? "red" : "#26a65b",
            }}
          >
            <Box className="filtertext">
              {item.header}:{" "}
              <span style={{ fontWeight: "500" }}>{item.label}</span>
            </Box>
            <Box className="delete-buttons-filter">
              <Box
                component="span"
                className="filter_switch"
                data-filter-id={key}
              >
                {!item.invert && (
                  <ToggleOnIcon
                    className="pointer"
                    //fontSize="large"
                    sx={{
                      position: "relative",
                      top: "4px",
                      fontSize: "35px",
                      marginRight: "5px",
                    }}
                  />
                )}

                {item.invert && (
                  <ToggleOffIcon
                    className="pointer"
                    //fontSize="large"
                    sx={{
                      position: "relative",
                      top: "4px",
                      fontSize: "35px",
                      marginRight: "5px",
                    }}
                  />
                )}
              </Box>

              <PowerSettingsNewRounded
                className="pointer filter_poweroff"
                //fontSize="medium"
                data-filter-id={key}
                sx={{ fontSize: "24px", top: "-3px", position: "relative" }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    );
    const gridItemHtml = renderToStaticMarkup(gridItem); // convert the JSX to HTML and add it to the grid
    return gridItemHtml;
  }
  function renderGridItem(item) {
    const gridItem = (
      <Box className="grid-stack-item" gs-w="3" gs-h="1">
        <Box className="grid-stack-item-content">
          <Box className="gridMini">
            <Box component="span" className="miniTitle">
              {item.d_name}
            </Box>
            <Box>
              <ZoomIn
                className="pointer expandGrid"
                sx={{ position: "relative", top: "3px", right: "4px" }}
                id={item.name}
              />
              <Computer
                className="pointer fullviewgrid"
                fontSize="small"
                id={item.name}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    );
    const gridItemHtml = renderToStaticMarkup(gridItem); // convert the JSX to HTML and add it to the grid
    return gridItemHtml;
  }
  function renderGridDetailsItem(item, height) {
    const gridItem = (
      <Box
        className="grid-stack-item grid-stack-container"
        //gs-w="3"
        widget-id={item.grid}
        //sx={{ height: height + "px !important" }}
      >
        {" "}
        {/**gs-h="1" */}
        <Box className="grid-stack-item-content">
          <Box
            style={{
              border: "1px solid #1976d2",
              //padding: "10px",
              borderRadius: "15px",
            }}
          >
            <Box className="gridHeader">
              <Box className="miniTitle" component={"span"}>
                {item.label}
              </Box>
              <Box>
                <Box
                  component={"span"}
                  sx={{ position: "relative", bottom: "5px", right: "7px" }}
                >
                  {sortBy?.label ? sortBy.label : "Impressions"}
                </Box>
                <ZoomOut
                  className="pointer zoomOut"
                  sx={{ position: "relative", top: "4px", right: "4px" }}
                  id={"zoom_" + item.grid}
                />
                <Computer
                  className="pointer"
                  fontSize="small"
                  id={"fullview_" + item.grid}
                />
              </Box>
            </Box>
            {item?.loader && item.loader == true && (
              <Box className="center">
                <img src={`${ASSET_IMAGES}/ad-loader.svg`} alt="Loader..." />
              </Box>
            )}

            <Box sx={{ paddingBottom: "25px" }}>
              <table style={{ width: "100%" }}>
                {item.data.map((rowData, index) => {
                  return (
                    <tr
                      key={index}
                      className="pointer expandedTableTr"
                      id={"filtersel_" + item.grid + "_" + rowData.id}
                      data-tableid={item.id}
                      data-rowid={rowData.id}
                      data-label={rowData.label}
                      data-header={item.label}
                    >
                      <td className="dt-left">{rowData.label}</td>
                      <td className="dt-right">
                        {nFormatter(rowData.value, 2)}
                      </td>
                    </tr>
                  );
                })}

                {item.loader == false && item.data.length <= 0 && (
                  <tr>
                    <td className="dt-left">No data available in table</td>
                  </tr>
                )}
              </table>
            </Box>
          </Box>
        </Box>
      </Box>
    );
    const gridItemHtml = renderToStaticMarkup(gridItem); // convert the JSX to HTML and add it to the grid
    return gridItemHtml;
  }

  const expandGridHandler = (grid = "") => {
    const foundItem = listGridTiles.find((item) => item.name === grid);
    if (typeof foundItem == "object" && Object.keys(foundItem).length > 0) {
      let newItem = {
        id: "",
        label: foundItem.d_name,
        grid: foundItem.name,
        loader: true,
        data: [],
      };
      addItemToMinimizedView(newItem);
    }

    setListGridTiles((prevGridTiles) => {
      // Create a new array with the same elements, but update the state property for the specified index.
      const updatedGridTiles = prevGridTiles.map((tile, i) => {
        if (tile.name === grid) {
          return {
            ...tile,
            state: 0,
          };
        }
        return tile;
      });
      return updatedGridTiles;
    });

    /***Call API For fetching Group By and Sort By data** */

    getMinimizedViewGridData(grid);
  };

  const zoomOutGridHandler = (grid) => {
    removeItemInMinimizedView(grid);
    setListGridTiles((prevGridTiles) => {
      // Create a new array with the same elements, but update the isActive property for the specified index.
      const updatedGridTiles = prevGridTiles.map((tile, i) => {
        if (tile.name === grid) {
          return {
            ...tile,
            state: 1,
          };
        }
        return tile;
      });
      return updatedGridTiles;
    });
  };

  const getMinimizedViewGridData = (grid) => {
    const type = sortBy?.value ? sortBy.value : "impressions";
    let payload = {
      dataview: props.profile_type,
      userData: {
        is_sys_admin: authUserData.is_sys_admin,
        user_id: authUserData.user_id,
        supply_dashboard_show_prices: authUserData.supply_dashboard_show_prices,
        supply_dashboard_price_percentage:
          authUserData.supply_dashboard_price_percentage,
        show_publisher_tile: false,
        company:
          authUserData?.user_assoc_companies?.length > 0
            ? authUserData?.user_assoc_companies[0]
            : "",
      },
      grid: grid,
      gridType: "SIMPLE",
      startdate: convertDateFormat(startdate, "MM/DD/YY"),
      enddate: convertDateFormat(enddate, "MM/DD/YY"),
      must: mustFilters,
      mustNot: mustNotFilters,
      aggs: [type],
      aggsort: type,
      ssptraffic: "all",
      traffic: "all",
    };
    dispatch(GetGraphAndSummaryDataThunk(payload))
      .then(unwrapResult)
      .then((res) => {
        let tableId = res?.data?.results?.id;
        let subType = res?.data?.results?.subtype;
        let dbdata = [];

        if (res?.data?.results?.data?.length > 0) {
          let resultData = res?.data?.results?.data;

          for (let i = 0; i < resultData.length; i++) {
            const rowInfo = resultData[i];
            dbdata.push({
              label: rowInfo[grid],
              value: rowInfo[type],
              id: rowInfo.id,
            });
          }
          updateItemInMinimizedView(subType, tableId, dbdata, false);
        } else {
          subType = subType != undefined ? subType : grid;
          updateItemInMinimizedView(subType, tableId, dbdata, false);
        }
      });
  };

  const addItemToMinimizedView = (ItemInfo) => {
    if (minimizedViewGridInstance) {
      var newHeight = ItemInfo.loader
        ? 200
        : Math.round(ItemInfo.data.length * 30 + 75);

      const itemHtml = renderGridDetailsItem(ItemInfo);
      const dataItem = minimizedViewGridInstance.addWidget(itemHtml, {
        sizeToContent: true,
        //autoPosition: true,
        w: 4,
        h: 7,
        id: ItemInfo.grid,
      });

      let zoomOutButton = document.querySelector("#fullview_" + ItemInfo.grid);
      zoomOutButton.addEventListener("click", function () {
        fullViewGridHandler(ItemInfo.grid);
      });
    }
  };

  const updateItemInMinimizedView = (grid, tableId, data, loader) => {
    const foundItem = listGridTiles.find((item) => item.name === grid);
    if (typeof foundItem == "object" && Object.keys(foundItem).length > 0) {
      let ItemInfo = {
        id: tableId,
        label: foundItem.d_name,
        grid: foundItem.name,
        loader: loader,
        data: data,
      };

      const widget = minimizedViewGridInstance
        .getGridItems()
        .find((widgetItem) => {
          // Replace "data-widget-id" with the actual attribute you use to identify widgets
          const widgetIdInGrid = widgetItem.getAttribute("widget-id");
          return widgetIdInGrid == grid;
        });

      if (widget) {
        var newHeight = ItemInfo.loader
          ? 200
          : Math.round(ItemInfo.data.length * 30 + 75);

        const itemHtml = renderGridDetailsItem(ItemInfo, newHeight);
        minimizedViewGridInstance.update(widget, {
          sizeToContent: true,
          //sizeToContent: 7,
          // autoPosition: true,
          w: 4,
          id: grid,
          content: itemHtml,
        });

        // minimizedViewGridInstance.update(widget, {
        //   sizeToContent: true,
        // });

        let zoomOutButton = document.querySelector("#zoom_" + ItemInfo.grid);
        zoomOutButton.addEventListener("click", function () {
          zoomOutGridHandler(ItemInfo.grid);
        });

        let fullViewButton = document.querySelector(
          "#fullview_" + ItemInfo.grid
        );
        fullViewButton.addEventListener("click", function () {
          fullViewGridHandler(ItemInfo.grid);
        });

        document
          .querySelectorAll(`[id^='filtersel_${ItemInfo.grid}_']`)
          .forEach((tr) => {
            tr.addEventListener("click", function () {
              let tableId = tr.getAttribute("data-tableid");
              let rowId = tr.getAttribute("data-rowid");
              let label = tr.getAttribute("data-label");
              let header = tr.getAttribute("data-header");

              addFilterBars(tableId, rowId, label, header, false);
            });
          });

        setTimeout(() => {
          minimizedViewGridInstance.resizeToContent(widget, true);
        }, 100);
      }
    }
  };

  const removeItemInMinimizedView = (grid) => {
    const widget = minimizedViewGridInstance
      .getGridItems()
      .find((widgetItem) => {
        // Replace "data-widget-id" with the actual attribute you use to identify widgets
        const widgetIdInGrid = widgetItem.getAttribute("widget-id");
        return widgetIdInGrid == grid;
      });
    if (widget) {
      minimizedViewGridInstance.removeWidget(widget);
    }
  };

  const addFilterBars = (tableId, rowId, label, header, invert) => {
    let uniqKey = tableId + "_" + rowId;
    let newFilterBars = {
      ...props.dashboardFilters.filterBars,
      [uniqKey]: {
        tableId: tableId,
        rowId: rowId,
        label: label,
        header: header,
        invert: invert,
        hidden: false,
      },
    };

    updateFilterBars(newFilterBars);

    //updateParentFilters
  };

  const toggleFilterBars = (filterKey) => {
    let newFilterBars = {
      ...filterBars,

      [filterKey]: {
        ...filterBars[filterKey],
        invert: !filterBars[filterKey].invert,
      },
    };

    updateFilterBars(newFilterBars);
  };

  const removeFilterBars = (filterKey) => {
    const updatedFilterBars = Object.fromEntries(
      Object.entries(filterBars).filter(([key]) => key !== filterKey)
    );
    updateFilterBars(updatedFilterBars);
  };

  const updateFilterBars = (newFilterBars) => {
    let mustFilters = {};
    let mustNotFilters = {};

    for (let n in newFilterBars) {
      let indFilter = newFilterBars[n];
      let tableId = indFilter.tableId;

      if (newFilterBars[n].invert) {
        if (!mustNotFilters.hasOwnProperty(tableId)) {
          mustNotFilters[tableId] = [];
        }
        mustNotFilters[tableId].push(indFilter.rowId);
      } else {
        if (!mustFilters.hasOwnProperty(tableId)) {
          mustFilters[tableId] = [];
        }
        mustFilters[tableId].push(indFilter.rowId);
      }
    }

    props.setDashboardFilters((prevState) => {
      return {
        ...prevState,
        mustFilters: mustFilters,
        mustNotFilters: mustNotFilters,
        filterBars: newFilterBars,
      };
    });
  };

  /*** Sudheer Code */
  const fullViewGridHandler = (grid) => {
    let tableColumns = [
      {
        field: grid,
        headerName: grid,
        flex: 1,
      },
    ];
    //Prepare table columns dynamically
    for (let k = 0; k < showsummaryfilters.length; k++) {
      let prefix =
        summary_options_ext[showsummaryfilters[k]]?.["prefix"] &&
        summary_options_ext[showsummaryfilters[k]]?.["prefix"] != ""
          ? summary_options_ext[showsummaryfilters[k]]?.["prefix"]
          : "";
      let indColumn = {
        field: showsummaryfilters[k],
        headerName: summary_options_ext[showsummaryfilters[k]]["label"],
        flex: 1,
        hide:
          summary_options_ext[showsummaryfilters[k]]["visible"] == false &&
          showsummaryfilters.length > 9
            ? true
            : false,
        renderCell: (params) => {
          if (params.id) {
            return (
              <Box>
                {prefix}
                {nFormatter(params.row[showsummaryfilters[k]], 2)}
              </Box>
            );
          }
        },
      };

      tableColumns.push(indColumn);
    }

    setFullViewGrid({
      key: grid,
      loader: true,
      data: [],
      id: "",
      columns: tableColumns,
      selFilters: [],
    });
    document.querySelector(".grid-stack-minimizedview").style.display = "none";
    document.querySelector(".grid-stack-list").style.display = "none";
    getFullViewData(grid);
  };

  const getFullViewData = (grid) => {
    const type = sortBy?.value ? sortBy.value : "impressions";
    let payload = {
      dataview: props.profile_type,
      userData: {
        is_sys_admin: authUserData.is_sys_admin,
        user_id: authUserData.user_id,
        supply_dashboard_show_prices: authUserData.supply_dashboard_show_prices,
        supply_dashboard_price_percentage:
          authUserData.supply_dashboard_price_percentage,
        show_publisher_tile: false,
        company:
          authUserData?.user_assoc_companies?.length > 0
            ? authUserData?.user_assoc_companies[0]
            : "",
      },
      grid: grid,
      gridType: "SIMPLE",
      startdate: convertDateFormat(startdate, "MM/DD/YY"),
      enddate: convertDateFormat(enddate, "MM/DD/YY"),
      must: mustFilters,
      mustNot: mustNotFilters,
      aggs: showsummaryfilters,
      aggsort: type,
      ssptraffic: "all",
      traffic: "all",
      size: 1000,
    };

    dispatch(GetGraphAndSummaryDataThunk(payload))
      .then(unwrapResult)
      .then((res) => {
        if (res?.data?.results?.data?.length > 0) {
          let resultData = res?.data?.results?.data;
          let tableId = res?.data?.results?.id;

          setFullViewGrid((prevState) => {
            return {
              ...prevState,
              loader: false,
              data: resultData,
              id: tableId,
              key: grid,
            };
          });
        } else {
          setFullViewGrid((prevState) => {
            return {
              ...prevState,
              loader: false,
              data: [],
            };
          });
        }
      });
  };
  //console.log("fullViewGrid:", fullViewGrid);
  const GridCheckBoxHandler = (from, argObj = {}) => {
    if (from == "checkbox") {
      console.log("argObj?.selIds:", argObj?.selIds);

      setFullViewGrid((prevState) => {
        return {
          ...prevState,
          selFilters: argObj?.selIds,
        };
      });
    } else if (from == "selButton") {
      if (fullViewGrid.selFilters?.length > 0) {
        applySelectedFiltersInFullView(false);
      }
    } else if (from == "rejButton") {
      if (fullViewGrid.selFilters?.length > 0) {
        applySelectedFiltersInFullView(true);
      }
    }
  };

  function removeKeysStartingWith(obj, prefix) {
    return Object.keys(obj).reduce((acc, key) => {
      if (!key.startsWith(prefix)) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  }

  const applySelectedFiltersInFullView = (invert) => {
    // first remove all the filters related to that tabel ID/ grid
    // then add those that are selected.

    let tableId = fullViewGrid.id;
    let grid = fullViewGrid.key;
    let header = fullViewGrid.key;

    let existingFilterBars = cloneDeep(props.dashboardFilters.filterBars);
    let filteredFilterBars = existingFilterBars;

    // if (invert == false) {
    //   //In case of Invert do not remove existing filters
    //   filteredFilterBars = removeKeysStartingWith(
    //     existingFilterBars,
    //     tableId + "_"
    //   );
    // }

    //console.log("existingFilterBars:", existingFilterBars);
    //console.log("After Remove existingFilterBars:", filteredFilterBars);

    const foundItem = listGridTiles.find((item) => item.name === grid);
    if (typeof foundItem == "object" && Object.keys(foundItem).length > 0) {
      header = foundItem.d_name;
    }

    let selFiltersInFullView = {};
    if (fullViewGrid.selFilters?.length > 0) {
      for (let k = 0; k < fullViewGrid.selFilters?.length; k++) {
        let uniqKey = tableId + "_" + fullViewGrid.selFilters[k];
        let rowId = fullViewGrid.selFilters[k];
        const foundObject = fullViewGrid.data.find((obj) => obj.id === rowId);
        let label =
          typeof foundItem == "object" && Object.keys(foundItem).length > 0
            ? foundObject[grid]
            : rowId;

        selFiltersInFullView = {
          ...selFiltersInFullView,
          [uniqKey]: {
            tableId: tableId,
            rowId: rowId,
            label: label,
            header: header,
            invert: invert,
            hidden: false,
          },
        };
      }
    }

    let newFilterBars = { ...filteredFilterBars, ...selFiltersInFullView };
    updateFilterBars(newFilterBars);
  };

  const closeFullViewGrid = () => {
    setFullViewGrid({});
    document.querySelector(".grid-stack-minimizedview").style.display = "block";
    document.querySelector(".grid-stack-list").style.display = "block";
  };

  //console.log("fullViewGrid:", fullViewGrid);

  return (
    //"display:none;padding-left: 5px;padding-right: 5px;"
    <>
      {/** Filter Bars View */}
      <Box className="grid-stack grid-stack-filterbars "></Box>

      {/** Tiles Minimized View */}
      <Box className="grid-stack grid-stack-minimizedview "></Box>

      {/** Tiles List*/}
      <Box className="grid-stack grid-stack-list"></Box>

      {/** Tiles Full View */}
      {Object.keys(fullViewGrid).length > 0 && (
        <Box sx={{ mb: 2, border: "1px solid #1976d2", borderRadius: "10px" }}>
          <Box className="closeFullView">
            <Close
              color="white"
              sx={{ float: "right", fontSize: "18px", cursor: "pointer" }}
              onClick={closeFullViewGrid}
              title="close"
            />
          </Box>
          <Box>
            <Box sx={{ p: 2, height: "500px" }}>
              {fullViewGrid.loader && (
                <Box className="center" sx={{ height: "100px" }}>
                  <img src={`${ASSET_IMAGES}/ad-loader.svg`} alt="Loader..." />
                </Box>
              )}
              {fullViewGrid.loader === false &&
                fullViewGrid.columns &&
                fullViewGrid.data.length >= 0 && (
                  <Datagrid
                    columns={fullViewGrid?.columns}
                    rows={fullViewGrid?.data}
                    checkbox={true}
                    checkBoxHandler={GridCheckBoxHandler}
                    page={fullViewGrid.key}
                    showDownloadButtons={true}
                    defaultSelectedIds={[
                      ...(mustFilters?.[fullViewGrid?.id]
                        ? mustFilters?.[fullViewGrid?.id]
                        : []),
                      ...(mustNotFilters?.[fullViewGrid?.id]
                        ? mustNotFilters?.[fullViewGrid?.id]
                        : []),
                    ]}
                    fileName={
                      props.profile_type.charAt(0).toUpperCase() +
                      props.profile_type.slice(1) +
                      "SupplyDashboard"
                    }
                  />
                )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default SupplyDashboardView;
